/**
 * Docs from
 * https://primeng.org/listbox
 */
export const listbox = {
  css: ({ dt }: { dt: any }) => `
    .p-listbox .p-listbox-list .p-listbox-option.p-listbox-option-selected.p-focus {
      background: ${dt('surface.0')} !important;
      color: ${dt('surface.950')} !important;
    }
    .p-listbox .p-listbox-list .p-listbox-option.p-listbox-option-selected {
      background: ${dt('surface.0')} !important;
      color: ${dt('surface.950')} !important;
    }
    .p-listbox:not(.p-disabled) .p-listbox-option.p-listbox-option-selected.p-focus {
      background: ${dt('surface.0')} !important;
      color: ${dt('surface.950')} !important;
    }
  `,
};
